import { Component, inject, OnInit, signal, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
import { UserService } from '../user.service';
import { Utente } from '../../../../shared/models/user.model';
import { HeaderComponent } from '../../shared/components/header/header.component';

@Component({
	selector: 'app-dati-personali',
	imports: [FormsModule, HeaderComponent],
	templateUrl: './dati-personali.component.html',
})
export class DatiPersonaliComponent implements OnInit {
	router = inject(Router);
	authService = inject(AuthService);
	userService = inject(UserService);

	utenteSignal = signal<Utente>({
		id: 0,
		nome: '',
		cognome: '',
		user: '',
		profilo: 0,
		titolo: '',
		attivo: true,
		cellulare: '',
		flgSignRemota: false,
		swsId: '',
		swsUser: '',
		cliente: { id: 0, logo: '', piva: '', ragioneSociale: '' },
	});
	loading = signal(false);
	success = signal(false);

	ngOnInit() {
		const current = this.authService.currentUser;
		if (current) this.utenteSignal.set({ ...current });
	}

	fullName = computed(() => {
		const u = this.utenteSignal();
		return u ? `${u.nome} ${u.cognome}` : '';
	});

	email = computed(() => {
		return this.utenteSignal()?.user ?? '';
	});

	salva() {
		this.loading.set(true);
		this.success.set(false);
		this.userService.updateUtente(this.utenteSignal()).subscribe({
			next: (updated) => {
				this.loading.set(false);
				this.success.set(true);
				localStorage.setItem('user', JSON.stringify(updated));
				setTimeout(() => this.success.set(false), 3000);
			},
			error: () => {
				this.loading.set(false);
			},
		});
	}

	goBack() {
		this.router.navigate(['/app/dashboard/profilo']);
	}
}
